// Default settings for ModIQ application
// These values can be modified to change application defaults

export const defaultSettings = {
  // Box Dimensions (feet)
  boxDimensions: {
    width: 13.7,
    length: 55.0
  },
  
  // Box Constraints (feet)
  boxConstraints: {
    minWidth: 12.29,
    maxWidth: 15.7,
    minLength: 45.0,
    maxLength: 68.0
  },
  
  // Building Constraints (number of boxes)
  buildingConstraints: {
    minBoxes: 3,
    maxBoxes: 50
  },
  
  // Building Settings (feet)
  building: {
    padding: 20.0,
    defaultFloors: 1,
    hasPodium: false,
    podiumHeight: 10.0
  },
  
  // Setback Defaults (feet)
  setbacks: {
    north: 10.0,
    east: 10.0,
    south: 10.0,
    west: 10.0,
    default: 30.0 // Used for new parcels
  },
  
  // Parcel Defaults (feet)
  parcel: {
    width: 200.0,
    length: 150.0
  },
  
  // Layout Strategy
  layout: {
    defaultStrategy: 'smart-hybrid'
  },
  
  // Display Settings
  display: {
    showDimensions: true,
    showGrid: true,
    gridSize: 10,
    showLivableSpacesTable: true
  },
  
  // Color Settings
  colors: {
    parcel: "#b1e3fa",
    buildableArea: "#b1e3fa",
    buildPath: "#FFFF00",
    buildingPadding: "#00FF00",
    box: "#FF5733",
    livableSpace: "#8BC34A",
    hallway: "#9E9E9E",
    grid: "#CCCCCC"
  },
  
  // Performance Settings
  performance: {
    standardEfficiency: 80.0,
    standardLivability: 80.0
  },
  
  // Advanced Cost Settings (currency)
  advanced: {
    components: {
      min: 135,
      max: 185
    },
    onSiteConstruction: {
      min: 100,
      max: 150
    }
  }
};

// Helper function to get a nested setting value
export const getSetting = (path) => {
  return path.split('.').reduce((obj, key) => obj?.[key], defaultSettings);
};

// Helper function to create a settings object for localStorage
export const createUserSettings = (overrides = {}) => {
  return {
    ...defaultSettings,
    ...overrides,
    lastUpdated: new Date().toISOString()
  };
};

export default defaultSettings; 